export { checkPartner } from './auth'

/**
 * Searches the Querystring for a parameter by the provided name
 * @param name {string}             Name of the query parameter
 * @param url {string, optional}    Will use window.location.href if ommitted
 * @returns {string, optional}                Returns the parameter or null if nothing was found.
 */
export const getParameterByName = (name: string, url?: string): string | null => {
  let _url = url
  if (!_url) _url = window.location.href
  // eslint-disable-next-line
  const _name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${_name}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(_url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
